import {
  MobizSettingsKey,
} from '../../common-react/settings';

export type PosturinnSettingsKey = MobizSettingsKey | 'PosturinnUserRecipients' | 'PosturinnUserOnboarding';
